<template>
  <el-dropdown @command="handleCommand" @visible-change="handleVisibleChange">
    <span class="avatar-dropdown">
      <el-avatar class="user-avatar" :src="avatar" />
      <div class="user-name">
        <span class="hidden-xs-only">{{ username }}</span>
        <vab-icon
          class="vab-dropdown"
          :class="{ 'vab-dropdown-active': active }"
          icon="arrow-down-s-line"
        />
      </div>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="personalInfo">
          <vab-icon icon="user-5-line" />
          <span>{{ translateTitle('编辑资料') }}</span>
        </el-dropdown-item>
        <el-dropdown-item command="personalCenter">
          <vab-icon icon="lock-2-line" />
          <span>{{ translateTitle('修改密码') }}</span>
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          <vab-icon icon="logout-circle-r-line" />
          <span>{{ translateTitle('退出登录') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <change-pwd ref="changepwd"></change-pwd>
  <edit-user ref="edituser" @fetch-data="fetchData"></edit-user>
</template>

<script>
import storejs from 'store'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { toLoginRoute } from '@/utils/routes'
import { translateTitle } from '@/utils/i18n'
import ChangePwd from '@/views/components/changepwd.vue'
import EditUser from '@/views/components/edituser.vue'

import defaultAvatar from '@/assets/defaultAvatar.png'
export default {
  name: 'VabAvatar',
  components:{ ChangePwd, EditUser },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const active = ref(false)
    const logout = () => store.dispatch('user/logout')
    const me = storejs.get('me')
    const changepwd = ref(null)
    const edituser = ref(null)
    const handleVisibleChange = (val) => {
      active.value = val
    }
    const handleCommand = async (command) => {
      switch (command) {
        case 'logout':
          await logout()
          //清除菜单
          store.dispatch('routes/setDynamicRoutes', [])
          storejs.clearAll()
          await location.reload()
          // await router.push(toLoginRoute(route.path))
          break
        case 'personalCenter':
          // await router.push('/settings/changepwd')
          console.log(changepwd.value)
          changepwd.value.showChangePWD()
          break
        case 'personalInfo':
          // await router.push('/settings/changepwd')
          console.log(edituser.value)
          edituser.value.showEditUser(me)
          break
      }
    }

    const avatar = ref(me && me.basic && me.basic.avatar || defaultAvatar)
    const username = ref(me && me.basic && me.basic.name)

    const state = {
      active,
      handleCommand,
      translateTitle,
      changepwd,
      edituser,
      handleVisibleChange,
      avatar,
      username,
      fetchData
    }

    function fetchData (me) {
      avatar.value = me && me.basic && me.basic.avatar || defaultAvatar
      username.value = me && me.basic && me.basic.name
    }
    return {
      ...state
    }
  },
}
</script>

<style lang="scss" scoped>
.avatar-dropdown {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;

  .user-avatar {
    width: 40px;
    height: 40px;
    margin-left: 15px;
    cursor: pointer;
    border-radius: 50%;
  }

  .user-name {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    height: 40px;
    margin-left: 6px;
    line-height: 40px;
    cursor: pointer;

    [class*='ri-'] {
      margin-left: 0 !important;
    }
  }
}
</style>
